import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Loadable from 'react-loadable';
import App from './common/App';
import { Provider } from 'react-redux';

import './resources/styles/index.scss';
import './App.css';
import './resources/styles/SlidePane.css';
import './index.css';
import { Event, initGA } from './Modules/LandingPageNew/Tracking/Track';
import { pageview } from 'react-ga';
import ResizeHandler from './ui-components/ResizeHandler';
import getReduxStore from './reducers/store';

const store = typeof window !== 'undefined' ? getReduxStore(window.__SERVER_DATA__) : null;

export const main = () => {
    Loadable.preloadReady().then(() => {
        initGA();
        pageview();
        Event('Partner Page', 'Landing Page is Viewed', '', '');
        ReactDOM.hydrate(
            // <ServerDataProvider value={serverData}>
            <Provider store={store}>
                <ResizeHandler/>
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </Provider>,
            // </ServerDataProvider>
            
            document.getElementById('root')
        );
    });
};

export { store };
